import { endPoints, requestType } from "../constants/variables";
import Api from "./index";

const getSettings = () => {
  return Api(endPoints.getSettings, requestType.GET);
};

const updateSettings = (id, params) => {
  return Api(`${endPoints.updateSettings}/${id}`, params, requestType.PUT);
};

export { getSettings, updateSettings };
